const ORDER_HISTORY_KEY = 'myshop_order_history';
const MAX_HISTORY_ITEMS = 20;

export function getSavedOrderIds() {
    try {
        const rawValue = localStorage.getItem(ORDER_HISTORY_KEY);
        const parsedValue = rawValue ? JSON.parse(rawValue) : [];

        if (!Array.isArray(parsedValue)) {
            return [];
        }

        return parsedValue
            .map(orderId => Number(orderId))
            .filter(orderId => Number.isInteger(orderId) && orderId > 0);
    } catch {
        return [];
    }
}

export function saveOrderToHistory(orderId) {
    const normalizedOrderId = Number(orderId);

    if (!Number.isInteger(normalizedOrderId) || normalizedOrderId <= 0) {
        return;
    }

    const nextOrderIds = [
        normalizedOrderId,
        ...getSavedOrderIds().filter(savedOrderId => savedOrderId !== normalizedOrderId)
    ].slice(0, MAX_HISTORY_ITEMS);

    localStorage.setItem(ORDER_HISTORY_KEY, JSON.stringify(nextOrderIds));
}

export function removeOrderFromHistory(orderId) {
    const normalizedOrderId = Number(orderId);
    const nextOrderIds = getSavedOrderIds().filter(savedOrderId => savedOrderId !== normalizedOrderId);

    localStorage.setItem(ORDER_HISTORY_KEY, JSON.stringify(nextOrderIds));
}
